import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HealthApplicationInfo } from './components';

import { Form } from '@ant-design/compatible';


import { Row } from 'antd';

import {
    getPagePermissions,
    CONFIG_APPLICATION
} from '../../security/permissions';

class HealthInformation extends Component {

    render() {
        return (
            <Row>
                <HealthApplicationInfo />
            </Row>
        );
    }

}

const HealthInformationForm = Form.create({ name: 'healthInformation' })(HealthInformation);


const mapStateToProps = ({ userData, userData: { permissions } }) => {
    return {
        userData,
        exportReportsPermissions: getPagePermissions(CONFIG_APPLICATION, permissions)
    };
};

export default connect(mapStateToProps)(HealthInformationForm);
